(() => {
  const TEMPLATE_ID = 'AdvanceCartUpsellTemplate';
  const HOST_CLASS = 'advance-cart-upsell-host';
  const SHIPPING_HOST_CLASS = 'advance-free-shipping-host';
  const FREE_SHIPPING_THRESHOLD = 14900;

  const formatSar = (cents) => {
    try {
      return new Intl.NumberFormat('ar-SA', {
        style: 'currency',
        currency: 'SAR',
        maximumFractionDigits: cents % 100 === 0 ? 0 : 2,
      }).format(cents / 100);
    } catch (_) {
      return `${(cents / 100).toFixed(2)} ر.س`;
    }
  };

  const injectUpsell = () => {
    const drawer = document.querySelector('cart-drawer');
    const inner = drawer?.querySelector('.drawer__inner');
    const footer = inner?.querySelector('.drawer__footer');
    const scrollArea = inner?.querySelector('cart-drawer-items');
    const template = document.getElementById(TEMPLATE_ID);
    if (!drawer || !inner || !footer || !scrollArea || !template || drawer.classList.contains('is-empty')) return;
    if (inner.querySelector(`.${HOST_CLASS}`)) return;

    const fragment = template.content.cloneNode(true);
    const currentVariants = new Set(
      Array.from(inner.querySelectorAll('[data-quantity-variant-id]'))
        .map((el) => String(el.dataset.quantityVariantId || ''))
        .filter(Boolean),
    );

    fragment.querySelectorAll('.advance-cart-upsell__item').forEach((card) => {
      if (currentVariants.has(String(card.dataset.variantId || ''))) card.remove();
    });

    const upsell = fragment.querySelector('[data-advance-cart-upsell]');
    if (!upsell || !upsell.querySelector('.advance-cart-upsell__item')) return;
    const host = document.createElement('div');
    host.className = HOST_CLASS;
    host.appendChild(upsell);
    scrollArea.appendChild(host);
  };

  let shippingRequestId = 0;
  const refreshFreeShipping = async () => {
    const drawer = document.querySelector('cart-drawer');
    const inner = drawer?.querySelector('.drawer__inner');
    if (!drawer || !inner) return;

    if (drawer.classList.contains('is-empty')) {
      inner.querySelector(`.${SHIPPING_HOST_CLASS}`)?.remove();
      return;
    }

    const requestId = ++shippingRequestId;
    try {
      const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (requestId !== shippingRequestId) return;

      const qualifiesByValue = Number(cart.total_price || 0) >= FREE_SHIPPING_THRESHOLD;
      const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - Number(cart.total_price || 0));
      const percent = qualifiesByValue
        ? 100
        : Math.max(0, Math.min(100, Math.round((Number(cart.total_price || 0) / FREE_SHIPPING_THRESHOLD) * 100)));

      let host = inner.querySelector(`.${SHIPPING_HOST_CLASS}`);
      if (!host) {
        host = document.createElement('div');
        host.className = SHIPPING_HOST_CLASS;
        const header = inner.querySelector('.drawer__header');
        if (header) header.after(host);
        else inner.prepend(host);
      }

      const headline = qualifiesByValue
        ? '✓ مبروك! طلبك مؤهل للشحن المجاني'
        : `باقي ${formatSar(remaining)} وتحصل على الشحن المجاني`;
      const subline = 'الشحن المجاني متاح للطلبات بقيمة 149 ر.س أو أكثر.';

      const stateKey = `${qualifiesByValue}-${remaining}-${percent}`;
      if (host.dataset.state === stateKey) return;
      host.dataset.state = stateKey;
      host.innerHTML = `
        <div class="advance-free-shipping${qualifiesByValue ? ' is-qualified' : ''}" role="status" aria-live="polite">
          <div class="advance-free-shipping__copy">
            <strong>${headline}</strong>
            <span>${subline}</span>
          </div>
          <div class="advance-free-shipping__track" aria-hidden="true">
            <span class="advance-free-shipping__bar" style="width:${percent}%"></span>
          </div>
        </div>`;
    } catch (error) {
      console.error('Advance free shipping:', error);
    }
  };

  let injectQueued = false;
  let shippingTimer = null;
  const scheduleInject = () => {
    if (!injectQueued) {
      injectQueued = true;
      requestAnimationFrame(() => {
        injectQueued = false;
        injectUpsell();
      });
    }
    window.clearTimeout(shippingTimer);
    shippingTimer = window.setTimeout(refreshFreeShipping, 120);
  };

  const boot = () => {
    injectUpsell();
    refreshFreeShipping();
    const drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(scheduleInject).observe(drawer, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-advance-upsell-add]');
    if (!button) return;
    const variantId = button.dataset.variantId;
    if (!variantId || !window.routes?.cart_add_url) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'جاري الإضافة...';
    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);

      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: formData,
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || 'Unable to add item');

      const drawer = document.querySelector('cart-drawer');
      if (drawer?.renderContents && data.sections) drawer.renderContents(data);
      else window.location.href = window.routes.cart_url;
      window.setTimeout(refreshFreeShipping, 80);
    } catch (error) {
      console.error('Advance cart upsell:', error);
      button.textContent = 'تعذر الإضافة';
      window.setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1600);
      return;
    }

    button.textContent = originalText;
    button.disabled = false;
  });
})();
